<template>
  <div class="ActivityHighlights">
    <my_title :content="title" :inputStyle="titleStyle"></my_title>
    <div class="content">
      <div class="images">
        <my_iwd v-for="(img, index) in hl.images" :key="img.desc" :src="img.src?img.src: tmpImg" :inputBG="calcBG(index)" :desc="img.desc" :width="imgWidth"></my_iwd>
      </div>
      <!-- <div class="redfile">
           <my_image :src="redFile" :width="rfWidth"></my_image>
           </div> -->
    </div>
  </div>
</template>

<script>
 import MyTitle from '@/components/Title.vue';
 import MyImage from '@/components/Image.vue';
 import MyIWD from '@/components/ImageWithDesc.vue';
 import hlImg from '@/assets/image/frontpage/hl-img.png';

 export default {
   name: '',
   props: ['hl'],
   computed: {
     title () {
       return '活动亮点'
     },
     titleStyle () {
       return {
         color: '#6C4DFF'
       }
     },
     redFile () {
       return "https://assets.koudashijie.com/aiyouth/images/frontpage/redfile.jpg"
     },
     imgWidth() {
       return this.$store.state.mediaPhone? '25vw': '18.3vw';
     },
     rfWidth () {
       return this.$store.state.mediaPhone? '22vw':'16.04vw'
     },
     tmpImg () {
       return hlImg
     }
   },
   methods: {
     calcBG (i) {
       return Object.assign({
         'background-image': 'url(' + require('../../assets/image/frontpage/hl'+i+'.png')+')'
       }, this.$store.state.frontpage.highlights.bgStyle)
     }
   },
   components: {
     my_title: MyTitle,
     my_image: MyImage,
     my_iwd: MyIWD
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .ActivityHighlights{
   display: flex;
   height: 30vw;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
 }
 .content{
   display: flex;
   width: 63vw;
   justify-content: space-between;
   align-items: center;
 }
 .redfile{
   width: 16.46vw;
   height: 23.17vw;
   display: flex;
   justify-content: center;
   align-items: center;

   background-color: #ffd2a0;
 }
 .images{
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   justify-content: space-between;
   /* width: 46vw; */
   height: 23.17vw;
 }
@media (min-width: 320px) and (max-width: 480px) {
  .ActivityHighlights{
    height: 47.62vw;
  }
  .content{
    width: 90vw;
  }
  .redfile{
    width: 22.9vw;
      height: 32.24vw;
  }
  .images{
    width: 64vw;
    height: 32.24vw;
  }
 }
</style>

